import RenderNodeFactory from "../RenderNodeFactory";
import {stikkord} from "../augmentations/stikkord/augmentation";
import {accountingTableLEGACY} from "./accountingTableLEGACY.augmentation";
import {sectionIconLinksLEGACY} from "./sectionIconLinksLEGACY.augmentation";
import {buildRuleset, type LegacyOverrides} from "../renderRules";
import {ExmarkLinkLEGACY} from "./ExmarkLinkLEGACY";
import {ExternalLinkLEGACY} from "./ExternalLinkLEGACY";
import {TableLEGACY} from "./TableLEGACY";
import {XboxLEGACY} from "./XboxLEGACY";

/**
 * Component overrides for the LEGACY-mode ruleset. Each entry maps a
 * rule's component slot (see `LegacyOverrides` in renderRules.tsx) to
 * its LEGACY-look twin. Step 4 of `.local/2026-05-21/standard-topic-
 * styling/PLAN.md` populates this as twins land.
 */
const LEGACY_OVERRIDES: LegacyOverrides = {
    Xbox: XboxLEGACY,
    ExmarkLink: ExmarkLinkLEGACY,
    ExternalLink: ExternalLinkLEGACY,
    Table: TableLEGACY,
};

// Section-icon-links runs BEFORE stikkord so that the header-wrapping
// step sees the raw section children (no Stikkord component present yet).
// Otherwise, the heuristic that picks the heading inside
// `SectionIconLinksLEGACY` can latch onto a Stikkord-augmented child and
// wrap the wrong element in `<header>`. Order-dependence is intentional —
// see `renderNodeLegacy.test.tsx` for the invariant.
const legacyAugmentations = [
    accountingTableLEGACY,
    sectionIconLinksLEGACY,
    stikkord,
];

const {renderNode, renderChildren, renderText} = RenderNodeFactory({
    ruleset: buildRuleset(LEGACY_OVERRIDES),
    augmentations: legacyAugmentations,
    modifiers: [],
});

export {renderNode, renderChildren, renderText};
